import { FC, Fragment } from 'react';
import { BREAKDOWN_AUDIENCE_ENGAGEMENT_HEADER } from 'modules/intelligentInsights/constants';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';
import {
  AudienceLiftContainer,
  AudienceLiftTitle,
  PrimaryText,
  PrimaryBoldBody1,
  AudienceEngagementMetrics,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/audienceLift/BreakdownAudienceLift.styles';
import {
  formatEngagementLift,
  getBreakdownAudienceEngagementConfig,
  getEngagementLiftByMedium,
} from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/breakdownUtils';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';

export const BREAKDOWN_AUDIENCE_ENGAGEMENT_TEST_ID = 'breakdown-audience-engagement';

export type BreakdownAudienceEngagementProps = {
  messageMedium: MessageMediumTab;
};

export const BreakdownAudienceEngagement: FC<BreakdownAudienceEngagementProps> = ({
  messageMedium,
}) => {
  const { froInsightsData } = useFroInsightsCoreContext();
  const [audienceMetricDisplayNames, audienceMetrics] =
    getBreakdownAudienceEngagementConfig(messageMedium);
  const metricsConfigValues = getEngagementLiftByMedium(froInsightsData, messageMedium);
  return (
    <AudienceLiftContainer data-test={BREAKDOWN_AUDIENCE_ENGAGEMENT_TEST_ID}>
      <AudienceLiftTitle>{BREAKDOWN_AUDIENCE_ENGAGEMENT_HEADER}</AudienceLiftTitle>
      <AudienceEngagementMetrics data-rowscount={audienceMetricDisplayNames.length}>
        {audienceMetrics.map((metric, index) => {
          const metricDisplayName = audienceMetricDisplayNames[index];
          const metricValue = metricsConfigValues[metric];
          return (
            <Fragment key={`${messageMedium}-${metric}`}>
              <PrimaryText>{metricDisplayName}</PrimaryText>
              <PrimaryBoldBody1>{formatEngagementLift(metricValue)}</PrimaryBoldBody1>
            </Fragment>
          );
        })}
      </AudienceEngagementMetrics>
    </AudienceLiftContainer>
  );
};
